import { defineComponent as d, openBlock as t, createElementBlock as s, normalizeClass as m, unref as u, createElementVNode as c, renderSlot as a, toDisplayString as o, createCommentVNode as n } from "vue";
import { c as f } from "./cn-Bje3WtSp.js";
const b = ["role"], g = { class: "flex-1" }, y = {
  key: 0,
  class: "font-semibold"
}, v = { key: 1 }, x = { key: 2 }, w = /* @__PURE__ */ d({
  __name: "Banner",
  props: {
    severity: { default: "info" },
    title: { default: void 0 },
    message: { default: void 0 },
    dismissible: { type: Boolean, default: !1 },
    class: { default: void 0 }
  },
  emits: ["dismiss"],
  setup(e) {
    const l = {
      success: "bg-success-muted border-success text-text-primary",
      info: "bg-info-muted border-info text-text-primary",
      warning: "bg-warning-muted border-warning text-text-primary",
      danger: "bg-danger-muted border-danger text-text-primary"
    };
    return (i, r) => (t(), s("div", {
      role: e.severity === "warning" || e.severity === "danger" ? "alert" : "status",
      class: m(u(f)(
        "flex w-full items-center gap-4 rounded-xl border px-5 py-4 text-sm",
        l[e.severity],
        i.$props.class
      ))
    }, [
      c("div", g, [
        a(i.$slots, "default", {}, () => [
          e.title ? (t(), s("span", y, o(e.title), 1)) : n("", !0),
          e.title && e.message ? (t(), s("span", v, " — ")) : n("", !0),
          e.message ? (t(), s("span", x, o(e.message), 1)) : n("", !0)
        ])
      ]),
      a(i.$slots, "actions"),
      e.dismissible ? (t(), s("button", {
        key: 0,
        type: "button",
        class: "rounded px-2 py-1 hover:bg-black/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand",
        "aria-label": "Dismiss",
        onClick: r[0] || (r[0] = (k) => i.$emit("dismiss"))
      }, " × ")) : n("", !0)
    ], 10, b));
  }
});
export {
  w as _
};
//# sourceMappingURL=Banner.vue_vue_type_script_setup_true_lang-BFz4MEYK.js.map
